// action
import {
    SAVE_COUPON,
    SAVE_COUPON_FAIL,
    SAVE_COUPON_SUCCESS,
    SAVE_COUPON_RESET
} from '../action/saveCouponAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_COUPON:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_COUPON_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_COUPON_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case SAVE_COUPON_RESET:
            return initialState
        default:
            return state
    }
}